import * as React from 'react';

function SvgChipOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M21 11H11v10h10zm-2 8h-6v-6h6z" />
      <path d="M30 13v-2h-4V6h-5V2h-2v4h-6V2h-2v4H6v5H2v2h4v6H2v2h4v5h5v4h2v-4h6v4h2v-4h5v-5h4v-2h-4v-6zm-6 11H8V8h16z" />
    </svg>
  );
}

export default SvgChipOutline;
